import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButton = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained Medium button (default)"}
        value={"<Button>Medium</Button>"}
      >
        <Button>Medium</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButton;
